import axios from 'axios';
import Swal from 'sweetalert2';
import router from '@/router';

function is_public_landing_route() {
  const current_path = router?.currentRoute?.value?.path || window.location.pathname || '';
  return current_path === '/' || current_path === '/jobs_advertised';
}

export function setup_logout_interceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const response = error.response;

      if (
        response &&
        response.status === 401 &&
        response.data?.detail === "User inactive or deleted."
      ) {
        if (is_public_landing_route()) {
          return Promise.reject(error);
        }
        Swal.fire({
          icon: 'error',
          title: 'Account Deactivated',
          text: 'You’ve been logged out because your account is inactive or deleted.',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          sessionStorage.clear();
          localStorage.clear();
          router.push({ name: 'UserLogin' });
        });
      }

      return Promise.reject(error);
    }
  );
}